/**
 * Envío AP-11 · deja armado el circuito en el Canvas: al lado del nodo que
 * recibió la captura crea el nodo de destino (Dream Actor, Banana 2 Pro…) y
 * los conecta. Mismo patrón que «Llevar al Canvas» de Editar imagen.
 */
import { useWorkflowStore } from '../../store/workflowStore';
import { destinationFor } from '../../utils/cameraCapture';

export function linkCaptureToDestination({ sourceNodeId, kind, destKey }) {
  const dest = destinationFor(kind, destKey);
  if (!dest?.type || !sourceNodeId) return null;
  const st = useWorkflowStore.getState();
  if (!st?.addNode) return null;
  const src = (st.nodes || []).find((n) => n.id === sourceNodeId);
  if (!src) return null;
  const pos = { x: (src.position?.x ?? 0) + 380, y: src.position?.y ?? 0 };
  const targetId = st.addNode(dest.type, pos, { ...(dest.data || {}) });
  st.onConnect({ source: sourceNodeId, target: targetId, sourceHandle: 'output', targetHandle: dest.handle });
  const connected = (useWorkflowStore.getState().edges || [])
    .some((e) => e.source === sourceNodeId && e.target === targetId && e.targetHandle === dest.handle);
  return { targetId, connected, label: dest.label };
}

/** Sólo los nodos de carga ofrecen armar el circuito; el resto recibe el archivo y listo. */
export function canLinkFrom(nodeId) {
  const st = useWorkflowStore.getState();
  const n = (st?.nodes || []).find((x) => x.id === nodeId);
  return n?.type === 'uploadVideo' ? 'video' : n?.type === 'uploadImage' ? 'image' : null;
}
